export const TOGGLE_LASSO = 'TOGGLE_LASSO';
export const TOGGLE_BLOCK_ON_CLICK = 'TOGGLE_BLOCK_ON_CLICK';



// WEBPACK FOOTER //
// ./src/common/Components/LassoSelection/state/types.js